.card {
  background: var(--surface);
  border: 1px solid var(--border);
  border-radius: var(--radius-lg);
  box-shadow: var(--shadow-sm);
  padding: 28px;
  min-width: 0;
}

.field {
  display: flex;
  flex-direction: column;
  gap: 6px;
  min-width: 0;
}

.label {
  font-weight: 500;
  font-size: 14px;
}

.input {
  width: 100%;
  min-height: 44px;
  border: 1px solid var(--border-strong);
  border-radius: var(--radius-sm);
  background: var(--surface);
  color: var(--text);
  font: inherit;
  padding: 10px 12px;
}

.input:hover {
  border-color: var(--text-faint);
}

.input:focus-visible {
  outline: 2px solid var(--accent);
  outline-offset: 1px;
}

.input[aria-invalid='true'] {
  border-color: var(--error);
}

.hint {
  margin: 0;
  color: var(--text-muted);
  font-size: 13px;
}

.fieldError {
  margin: 0;
  color: var(--error);
  font-size: 13px;
}

.checkbox {
  display: flex;
  gap: 10px;
  align-items: flex-start;
  font-size: 14px;
  color: var(--text-secondary);
}

.checkbox input {
  width: 18px;
  height: 18px;
  margin: 2px 0 0;
  flex: none;
}

.button {
  min-height: 44px;
  border-radius: var(--radius-pill);
  border: 1px solid transparent;
  font: inherit;
  font-weight: 600;
  padding: 10px 20px;
  cursor: pointer;
  transition:
    background-color 0.2s var(--ease),
    border-color 0.2s var(--ease);
}

.button:disabled {
  cursor: not-allowed;
  opacity: 0.6;
}

.primary {
  background: var(--primary);
  color: #fff;
}

.primary:hover:not(:disabled) {
  background: #000;
}

.secondary {
  background: var(--surface);
  border-color: var(--border-strong);
  color: var(--text);
}

.secondary:hover:not(:disabled) {
  background: var(--surface-soft);
}

.ghost {
  background: transparent;
  color: var(--accent-strong);
  padding-inline: 8px;
}

.ghost:hover:not(:disabled) {
  text-decoration: underline;
}

.notice {
  border-radius: var(--radius-sm);
  border: 1px solid var(--border);
  padding: 12px 14px;
  font-size: 14px;
}

.error {
  background: #fef2f2;
  border-color: rgba(220, 38, 38, 0.3);
  color: #991b1b;
}

.success {
  background: #f0fdf4;
  border-color: rgba(21, 128, 61, 0.3);
  color: #14532d;
}

.info {
  background: var(--surface-blue);
  border-color: var(--accent-soft);
  color: var(--text-secondary);
}
